
function ChurchesEn() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/church_banner.JPG" alt="church" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Wismar's churches</h1>
                            <p>Did you know that in the Middle Ages, the number of churches in a town represented 
                                its wealth? Wismar has 4 of them and was a wealthy town at the time of the Hanseatic 
                                League in the 13th century. The sacred buildings still bear witness to this today.
                            </p>
                        </div>
                        <div className="text">
                            <h2>St. Georgen</h2>
                            <p>Built in the 13th century and completed in its entirety over 300 years later, St George's 
                                Church is an imposing building that can be admired and explored with its reopening in 2010. 
                                Just an 8-minute walk from Apartment 5, the church blends seamlessly into the south-west 
                                of the old town. On the viewing platform you can explore Wismar from above.
                            </p>
                        </div>
                        <div className="text">
                            <h2>St. Nikolai</h2>
                            <p>Built in the 14th and 15th centuries, St Nicholas' Church in the small town of Wismar 
                                is one of the largest churches in Central Europe. Situated directly on the Frische Grube, 
                                it offers a unique visual experience of the long past century of contemporary history. 
                                <br></br>Situated between today's railway station and the market square, it is impossible 
                                to miss the building. The pavement nestles close to the high walls, while the tower and nave 
                                can be guessed at rather than seen in their entirety due to the height. Simply an impressive 
                                building and definitely worth a visit.
                            </p>
                        </div>
                        <div className="text">
                            <h2>St. Marien</h2>
                            <p>Also built in the 13th century but only with the church tower remaining today: St Mary's 
                                Church. The nave, which was blown up in the middle of the last century, has now been 
                                reconstructed. The proportions give an idea of the dimensions of the original building. 
                                <br></br>The tower can be seen from Apartment 5, and even in today's digital age, the tower 
                                clock is a practical time indicator when taking time out on the roof.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Heiligen Geist</h2>
                            <p>Its construction also dates back to the 13th century. In contrast to the other three churches, 
                                the Church of the Holy Spirit served as a hospital church and is hardly recognisable as a 
                                typical church from the outside at first glance. Blending in with the surrounding buildings, 
                                it is also the inner courtyard with garden that makes this church an architectural idyll worth 
                                seeing.<br></br>The inner courtyard became famous in one of the first horror films called 
                                Nosferatu, which was filmed at several locations in Wismar in 1921, including here.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default ChurchesEn;